// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-6-m__wrapper__bpH7-"};